import styled from "styled-components";
import { StyledListSectionBody } from "app/pages/sales-intelligence/modules/lists/components/styles";

export const StyledListsSectionHeader = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledTooltipContent = styled.div`
    margin-left: 12px;
    cursor: pointer;
`;

export const StyledCRMListsSectionBody = styled(StyledListSectionBody)`
    margin-top: 12px;
`;

export const StyledListsSection = styled.div`
    margin-top: 36px;
    padding-bottom: 64px;
`;
